import { render } from "./IconGlobeOutline.vue?vue&type=template&id=8b262c78"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconGlobeOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b262c78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b262c78', __exports__)) {
    api.reload('8b262c78', __exports__)
  }
  
  module.hot.accept("./IconGlobeOutline.vue?vue&type=template&id=8b262c78", () => {
    api.rerender('8b262c78', render)
  })

}


export default __exports__